import { Collection } from 'modules/core/lib/mobx-rest'

import BankAccount from 'modules/payroll_bundle/store/models/BankAccount'

class BankAccounts extends Collection<BankAccount> {
  get cacheKey(): string {
    return 'bankAccounts'
  }

  model() {
    return BankAccount
  }
}

const singleton: BankAccounts = new BankAccounts()

export default singleton
